import React from "react";

function LuckydrawPartners() {
  return (
    <>
      <div className="container text-center partners">
        <div className="row">
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-1.jpg')} alt="partners" />
          </div>
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-2.jpg')} alt="partners" />
          </div>
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-3.jpg')} alt="partners" />
          </div>
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-4.jpg')} alt="partners" />
          </div>
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-5.jpg')} alt="partners" />
          </div>
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-6.jpg')} alt="partners" />
          </div>
          <div className="col-md-12">
            <img src={require('../../assets/img/partners/partners-7.jpg')} alt="partners" />
          </div>
        </div>
      </div>
    </>
  );
}

export default LuckydrawPartners;
